export default __webpack_public_path__ + "static/media/phoneblue.e7db3103.png";